import { jsx as _jsx } from "react/jsx-runtime";
import sanitizeHtml from "sanitize-html";
export const Sanitize = ({ html, className }) => {
    const sanitizedHTML = sanitizeHtml(html, {
        allowedTags: ["a", "b", "br", "i", "em", "strong", "p", "span"],
        allowedAttributes: {
            a: ["href", "target", "rel", "class"],
            "*": ["class"],
        },
    });
    return (_jsx("span", { className: className, dangerouslySetInnerHTML: { __html: sanitizedHTML } }));
};
//# sourceMappingURL=Sanitize.js.map